var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body",attrs:{"id":"poll-view"}},[_c('div',{staticClass:"body-inner"},[_c('Simplebar',{staticClass:"body-simplebar",attrs:{"data-simplebar-auto-hide":"false"}},_vm._l((_vm.filteredQuestions),function(ref,index){
var id = ref.id;
var idx = ref.idx;
var answers = ref.answers;
return _c('PollQuestion',{key:id,attrs:{"id":id,"idx":idx,"answers":answers,"total":_vm.questionsTotalCount}})}),1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }